export default __webpack_public_path__ + "static/media/10.cd3de3be.png";